import * as React from 'react';
import { IconPaths } from 'src/icons';

interface Props {
  onClick: () => void;
  style?: React.CSSProperties;
  className?: any;
  title?: string;
}

const PrintButton: React.SFC<Props> = ({ onClick, style, className, title }: Props) => (
  <React.Fragment>
    <div className={'pointer utilButton ' + className} onClick={onClick} style={style}>
      <span>Drucken</span>
      <img title={title} src={IconPaths['print-icon']} />
    </div>
  </React.Fragment>
);

export default PrintButton;



// WEBPACK FOOTER //
// ./src/components/utils/PrintButton/PrintButton.tsx